import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=24e1d0c6&scoped=true"
import script from "./scroll.vue?vue&type=script&lang=js"
export * from "./scroll.vue?vue&type=script&lang=js"
import style0 from "./scroll.vue?vue&type=style&index=0&id=24e1d0c6&prod&lang=less&scoped=true"
import style1 from "./scroll.vue?vue&type=style&index=1&id=24e1d0c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1d0c6",
  null
  
)

export default component.exports